<template>
  <!-- <GenericLayout :title="$t('LOGIN.TITLE')" class="fill-height"> -->
    <v-row no-gutters class="fill-height">
      <v-col
        md="8"
        cols="12"
        class="register-hero hidden-sm-and-down"
      ></v-col>

      <v-col
        md="4"
        cols="12"
        class="px-4 py-10"
      >
        <!-- <h1 v-if="isLogged">
          {{ $t('LOGGING_OUT') }}
        </h1>
        <h1 v-else class="text-center">
          {{ $t('LOGGED_OUT') }}
        </h1> -->
        <h1 class="text-center">
          {{ $t('LOGGED_OUT') }}
        </h1>

        <BaseButton
          class="my-2"
          @click="$router.replace({ name: 'home' })"
        >
          {{ $t('PLAY_AGAIN') }}
        </BaseButton>
        <BaseButton
          class="my-2"
          color="#f0f0f0"
          @click="$router.replace({ name: 'login' })"
        >
          {{ $t('LOGIN.TITLE') }}
        </BaseButton>
        <BaseButton
          class="mb-4"
          color="#f0f0f0"
          @click="$router.replace({ name: 'register' })"
        >
          {{ $t('REGISTER.TITLE') }}
        </BaseButton>
      </v-col>
    </v-row>
  <!-- </GenericLayout> -->
</template>

<style scoped>
.register-hero {
  background-image: url('../assets/img/promo-md-2x.png');
  background-size: cover;
}
</style>

<script>
// import GenericLayout from '@/layouts/GenericLayout.vue';

export default {
  name: 'Logout',
  computed: {
    isLogged() {
      const { session } = this.$store.state;
      return session.isLogged;
    },
    loading() {
      return this.$store.state.session.isLoading;
    },
  },
  created() {
    // const loggedIn = this.$store.state.session.isLogged;
    const { isLogged, justLoggedOut } = this.$store.state.session;

    // if (loggedIn) {
    if (isLogged && !justLoggedOut) {
      this.$store.dispatch('settings/reset');
      this.$store.dispatch('session/logout')
        .then(() => {
          this.$store.dispatch('session/justLoggedOut');
          // this.$router.go();
        });
    }
  },
  beforeDestroy() {
    this.$store.dispatch('session/justLoggedIn');
  },
};
</script>
